//require("dotenv").config();

const Base_Api_Url = process.env.REACT_APP_API_URL; //https://aap-webapi.azurewebsites.net/    //http://localhost:4000/
const Base_APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL;
const Base_HUBSPOT_FORM_ID = process.env.REACT_APP_HUBSPOT_FORM_ID;
const Base_HUBSPOT_PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
const Base_AI_WORKSHOP_URL = process.env.REACT_APP_AI_WORKSHOP_URL;
const Base_AZURE_STORAGE_CONNECTION_STRING =
  process.env.REACT_APP_AZURE_STORAGE_CONNECTION_STRING;

export {
  Base_Api_Url,
  Base_APPLICATION_URL,
  Base_HUBSPOT_FORM_ID,
  Base_HUBSPOT_PORTAL_ID,
  Base_AI_WORKSHOP_URL,
  Base_AZURE_STORAGE_CONNECTION_STRING,
};
